// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__1nA3U","savePackageButton":"ClientWallet_savePackageButton__2cQnW"};